import type { TReviewCompactProps, TReviewCompactSizes } from "./types";
import * as Comp from "./review-compact.styles";
import { Rating } from "../rating";
import { TouchableOpacity, View } from "react-native";
import type { TRatingSizes } from "../rating/types";
import { ReviewCount } from "./components/review-count";

const ReviewCompact = ({
  children,
  size = "medium",
  value,
  reviewCount,
  onPress,
  testID = "review-compact-root",
  ...props
}: TReviewCompactProps) => {
  const ratingValue = value > 5 ? 5 : value < 0 ? 0 : value;
  const sizeToRatingSize = {
    small: "tiny",
    medium: "small",
  } satisfies Record<TReviewCompactSizes, TRatingSizes>;

  return (
    <Comp.Root size={size} testID={testID} {...props}>
      <Rating
        size={sizeToRatingSize[size]}
        value={ratingValue}
        testID="review-compact-rating"
      />
      <View style={{ flexDirection: "row", alignItems: "center", gap: 4 }}>
        <Comp.RatingValue size={size} testID="review-compact-rating-value">
          {ratingValue.toLocaleString("pt-BR", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })}
        </Comp.RatingValue>
        {onPress ? (
          <TouchableOpacity
            style={{ alignItems: "center", justifyContent: "center" }}
            onPress={onPress}
            testID="review-compact-count-touchable"
          >
            <ReviewCount size={size} reviewCount={reviewCount} />
          </TouchableOpacity>
        ) : (
          <ReviewCount size={size} reviewCount={reviewCount} />
        )}
      </View>
    </Comp.Root>
  );
};

export { ReviewCompact, type TReviewCompactProps };
